import { t } from "i18next";
import React, { useState } from "react";
import "./BetId.scss";

const BetId = () => {
  const [inputValue, setInputValue] = useState("");
  const [inputFocused, setInputFocused] = useState(false);

  const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const inputFocus = () => {
    setInputFocused(true);
  };

  const inputBlur = () => {
    setInputFocused(false);
  };

  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default ${inputFocused ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            value={inputValue}
            type="text"
            inputMode="decimal"
            className="form-control-input-bc"
            name="bet_id"
            step={0}
            defaultValue=""
            onChange={handleChangeValue}
            onFocus={inputFocus}
            onBlur={inputBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">{t("admin.BetID")}</span>
        </label>
      </div>
    </div>
  );
};

export { BetId };
